/** DE Ella-chat preview opt-in. Reveals the Ella chat launcher for one visitor
 *  in the German market via a `?ella-de=<ELLA_DE_PREVIEW_TOKEN>` magic link,
 *  BEFORE `feature:chat` is widened to include `de` in the country-gate registry.
 *
 *  Distinct from `de-preview` (the route gate that hides the whole `/de/*` tree
 *  until DE is public): DE is already live, so that gate is off — this only
 *  unlocks the not-yet-launched chat widget. Mirrors lib/ai-preview.ts; the
 *  difference is that ai-preview stays inside the CH `feature:chat` gate, whereas
 *  this one is what crosses the country gate for DE. */
export const ELLA_DE_PREVIEW_TOKEN_COOKIE = "ella-de-preview"
export const ELLA_DE_PREVIEW_ACTIVE_COOKIE = "ella-de-preview-active"
export const ELLA_DE_PREVIEW_PARAM = "ella-de"

/** True when the visitor opted into the DE Ella-chat preview. Client-only —
 *  reads `document.cookie`, returns false during SSR so it never forces a page
 *  dynamic (the launcher is `ssr:false` and mounts post-hydration anyway). */
export function hasEllaDePreviewActive(): boolean {
  if (typeof document === "undefined") return false
  return document.cookie
    .split("; ")
    .includes(`${ELLA_DE_PREVIEW_ACTIVE_COOKIE}=1`)
}
